import type { ImgHTMLAttributes, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import enLogoUrl from "@/assets/logos/en-logo.svg?url";
import arLogoUrl from "@/assets/logos/ar-logo.svg?url";

export function BrandLogoIcon(
  props: ImgHTMLAttributes<HTMLImageElement>,
): ReactElement {
  const { i18n } = useTranslation();
  const isArabic = i18n.language.startsWith("ar");
  const src = isArabic ? arLogoUrl : enLogoUrl;

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={97}
      height={19}
      style={{ display: "block", objectFit: "contain" }}
      {...props}
    />
  );
}
